import React from 'react';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import Layout from '@/layouts';

import styles from './index.module.scss';

export type AboutServiderProps = Record<string, never>;
export const getServerSideProps: GetServerSideProps<AboutServiderProps> = async ({ res }) => {
  res.setHeader('Cache-Control', 'public, s-maxage=15, stale-while-revalidate=59');
  return {
    props: {},
  };
};

function About({}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <>
      <Layout
        title="关于中国新消费品牌库| CBNData品牌数集"
        description="CBNData品牌数集是第一财经商业数据中心（CBNData）旗下一款衡量品牌综合实力的可视化数据工具，基于CBNData沉淀的中国新消费品牌增长力评估模型与数据能力，从品牌赛道潜力、组织能力、经营能力、产品竞争力、营销能力、供应链能力、用户发展能力等7个维度，系统化帮助投资人及品牌创始人衡量品牌综合实力、评估品牌风险、分析行业竞争格局以及挖掘高增长潜力的新锐品牌。"
        keyword="消费、新消费、中国新消费、品牌、数据、数据库、国货、国潮、增长、风险评估、行业、赛道、竞品、组织、公司、产品、营销、供应链、用户、数据工具、数据可视化，品牌数集、CBNData、CBN、第一财经"
        isFrapMain
      >
        <div className={styles.contentContainer}>
          <p className={styles.content}>
            CBNData品牌数集是第一财经商业数据中心（CBNData）旗下一款衡量品牌综合实力的可视化数据工具，基于CBNData沉淀的中国新消费品牌增长力评估模型与数据能力，从品牌赛道潜力、组织能力、经营能力、产品竞争力、营销能力、供应链能力、用户发展能力等7个维度，系统化帮助投资人及品牌创始人衡量品牌综合实力、评估品牌风险、分析行业竞争格局以及挖掘高增长潜力的新锐品牌。
          </p>
        </div>
      </Layout>
    </>
  );
}

export default About;
